<template>
    <div class="container">
        <div class="mt-5">
            <div class="card">
                <div class="card-body">
                    <div class="title text-center">
                        <div class="main-title">Abdi<span class="text-primary">Social</span></div>
                        <div class="sub-title mt-1">Daftar Akun</div>
                    </div>

                    <div class="mt-4">
                        <div class="alert alert-danger small" v-if="error.register">
                            <template v-if="error.register == 'error'">Terjadi kesalaham, silahkan coba lagi.</template>
                            <template v-else-if="error.register == 'email-exists'">Email sudah digunakan, coba yang lain.</template>
                            <template v-else-if="error.register == 'username-exists'">Username sudah digunakan, coba yang lain.</template>
                            <template v-else-if="error.register == 'invalid-email'">Format email salah, silahkan coba lagi.</template>
                        </div>

                        <div class="form-group">
                            <vs-input v-model="form.name" placeholder="Nama" type="text">
                                <template #icon>
                                    <box-icon name="user"></box-icon>
                                </template>

                                <template v-if="submitted && form.name == ''" #message-danger>Nama tidak boleh kosong</template>
                            </vs-input>
                        </div>
                        <div class="form-group">
                            <vs-input v-model="form.username" placeholder="Username" type="text">
                                <template #icon>
                                    <box-icon name="user"></box-icon>
                                </template>

                                <template v-if="submitted && form.username == ''" #message-danger>Username tidak boleh kosong</template>
                            </vs-input>
                        </div>
                        <div class="form-group">
                            <vs-input v-model="form.phone" placeholder="Nomor Ponsel" type="number">
                                <template #icon>
                                    <box-icon name="phone"></box-icon>
                                </template>

                                <template v-if="submitted && form.phone == ''" #message-danger>Telepon tidak boleh kosong</template>
                            </vs-input>
                        </div>
                        <div class="form-group">
                            <vs-input v-model="form.email" placeholder="Email" type="email">
                                <template #icon>
                                    <box-icon name="mail-send"></box-icon>
                                </template>

                                <template v-if="!validEmail && form.email !== ''" #message-danger>Email Invalid</template>
                                <template v-else-if="submitted && form.email == ''" #message-danger>Email tidak boleh kosong</template>
                            </vs-input>
                        </div>
                        <div class="form-group">
                            <vs-input v-model="form.password" placeholder="Password" type="password">
                                <template #icon>
                                    <box-icon name="lock"></box-icon>
                                </template>

                                <template v-if="submitted && form.password == ''" #message-danger>Password tidak boleh kosong</template>
                            </vs-input>
                        </div>

                        <div class="mt-4">
                            <vs-button block :loading="loading.register" @click="registerAccount()">Daftar</vs-button>
                            <div class="mt-2">
                                <vs-button block border @click="actionTo('login')" :loading="loading.register">Kembali ke Login</vs-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { usersCollection } from '@/helpers/firebase';
import accountHelper from '@/helpers/account';
import firebase from 'firebase';

export default {
    data() {
        return {
            form: {
                name: '',
                username: '',
                phone: '',
                email: '',
                password: '',
            },
            submitted: false,
            loading: {
                register: false,
            },
            error: {
                register: '',
            }
        }
    },
    methods: {
        actionTo(url) {
            this.$router.push({ path: url });
        },
        registerAccount() {
            this.submitted = true;
            this.loading.register = true;
            this.error.register = '';

            let account = this.form;
            if(account.name && account.username && account.phone && account.email && account.password) {
                if(this.validEmail) {
                    account.username = account.username.toLowerCase().replace(/\s/g, '');
                    account.email = account.email.toLowerCase().replace(/\s/g, '');
                    account.created_at = new Date();
    
                    firebase.auth().createUserWithEmailAndPassword(account.email, account.password).then(() => {
                        usersCollection.where('username', '==', account.username).get().then(snapshot => {
                            if(snapshot.size == 0) {
                                usersCollection.doc(account.email).set(account);
                                accountHelper.saveToLocalStorage(account);
    
                                this.$router.push({ path: '/' });
                            } else {
                                firebase.auth().currentUser.delete();
                                this.error.register = 'username-exists';
                                this.loading.register = false;
                            }
                        }).catch(err => {
                            this.error.register = 'error';
                            this.loading.register = false;
                            console.log('error', err);
                        })
                    }).catch(err => {
                        if(err.code == 'auth/email-already-in-use') {
                            this.error.register = 'email-exists';
                        } else if(err.code == 'auth/invalid-email') {
                            this.error.register = 'invalid-email.';
                        } else {
                            this.error.register = 'error';
                        }
    
                        this.loading.register = false;
                    });
                } else {
                    this.loading.register = false;
                }
            } else {
                this.loading.register = false;
            }
        },
    },
    computed: {
        validEmail() {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email) // eslint-disable-line
        }
    }
}
</script>

<style scoped>
@import '../../styles/auth.css';
</style>